import React, {useState, useEffect, useRef, useContext} from "react";
import axios from "axios";
import {Link, useHistory, useParams} from 'react-router-dom'
import Card from "../../../components/Card";
import {Field, Form, Formik} from "formik"
import ModalMsg from "../../../components/ModalMsg";
import * as Yup from "yup";
import {LoaderContext} from "../../../context/LoaderContext";

function ModificaPartner() {
    const {id} = useParams()

    const iconaDefault = 'fas fa-cogs';

    const [loadingData, setLoadingData] = useState(true);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    const history = useHistory();
    const formikRef = useRef();

    useEffect(() => {
        async function getData() {
            startChiamata()
            await axios
                .get(process.env.REACT_APP_API_ENDPOINT + "/api/cmms/partner/" + id) 
                .then((response) => {
                    setLoadingData(false);

                    if (formikRef.current) {                
                        formikRef.current.setFieldValue("id_partner", response.data.data.id_partner)      
                        formikRef.current.setFieldValue("descrizione", response.data.data.descrizione)                        
                    }
                    endChiamata()
                });
        }

        if (loadingData) {
            if (id && id !== '') {
                getData();
            }
        }
    }, []);

    const closeModal = () => setShow(false);

    const SignupSchema = Yup.object().shape({
        descrizione: Yup.string()
            .max(200, 'Valore troppo lungo')
            .required('Questo campo è obbligatorio')
    });

    return (
        <div>
            <ModalMsg
                show={show}
                handleClose={closeModal}
                testo={modalMsg}/>
            <div className={"row"}>
                <div className={"col-md-12"}>
                    <Card
                        icon={'fas fa-users'}
                        title={id ? 'Modifica Partner Oggetto' : 'inserisci Partner Oggetto'}
                        getBottoniSx={() =>
                            <Link to={"/conf-partners"} className="btn btn-card">
                                <i className="fas fa-angle-left"/>
                            </Link>
                        }
                        getBottoniDx={() =>
                            <button type="button" id="salva" name="salva"
                                    className="btn btn-card"
                                    onClick={() => {
                                        if (formikRef.current) {
                                            formikRef.current.handleSubmit()
                                        }
                                    }}>
                                <i className="fas fa-save"/> <span className={'cmms-display-mobile'}>Salva</span>
                            </button>
                        }>
                        <Formik
                            initialValues={{
                                id_partner: '',
                                descrizione: '',
                            }}
                            innerRef={formikRef}
                            validationSchema={SignupSchema}
                            onSubmit={values => {
                                if (id) {
                                    startChiamata()
                                    axios
                                        .put(process.env.REACT_APP_API_ENDPOINT + "/api/cmms/partner/" + id,
                                            values)
                                        .then((response) => {
                                            if (response.data.result === 0) {
                                                history.push("/conf-partners");
                                            } else {
                                                setModalMsg(response.data.description);
                                                setShow(true);
                                            }
                                            endChiamata()
                                        });
                                } else {
                                    startChiamata()
                                    axios
                                        .post(process.env.REACT_APP_API_ENDPOINT + "/api/cmms/partner/",
                                            values)
                                        .then((response) => {
                                            if (response.data.result === 0) {
                                                history.push("/conf-partners");
                                            } else {
                                                setModalMsg(response.data.description);
                                                setShow(true);
                                            }
                                            endChiamata()
                                        });
                                }
                            }}
                        >
                            {({errors, touched, values}) => (
                                <Form className="row g-3">

                                    <div className="col-md-6">
                                        <label htmlFor="descrizione" className="form-label">Descrizione*:</label>
                                        <Field name="descrizione" className="form-control"/>
                                        {errors.descrizione && touched.descrizione ? (
                                            <div className="cmms-div-err-form">{errors.descrizione}</div>
                                        ) : null}
                                    </div>
                                    {/* <div className="col-md-6">
                                        <label htmlFor="endpoint" className="form-label">Endpoint:</label>
                                        <Field name="endpoint" className="form-control"/>
                                        {errors.endpoint && touched.endpoint ? (
                                            <div className="cmms-div-err-form">{errors.descrizione}</div>
                                        ) : null}
                                    </div> */}

                                </Form>
                            )}
                        </Formik>
                    </Card>
                </div>
            </div>
        </div>
    );
}

export default ModificaPartner;